var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-popup',{attrs:{"extra-class":"complete-registration-popup no-transparent","disable-close":true}},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"popup-title"},[_vm._v(_vm._s(_vm.$t('auth.please_complete_account')))]),_c('complete-registration-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }